import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Modal, Form, Input, Button } from 'semantic-ui-react'

import GeoCategoriesDropdown from './fields/GeoCategoriesDropdown'
import {
  closeModal, createGeoSection, updateGeoSection, deleteGeoSection,
} from '../actions/geoSections'


class SectionModal extends React.Component {
  defaultState = { name: '', categories: [] }

  constructor(props) {
    super(props)
    this.state = { ...this.defaultState }
  }

  componentDidUpdate(prevProps) {
    const { sectionId, geoSections, open } = this.props
    if (open && !prevProps.open) {
      if (sectionId) {
        const { name, categories } = geoSections[sectionId]
        this.setState({ name, categories })
      } else this.setState({ ...this.defaultState })
    }
  }

  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  handleSave = () => {
    const { createGeoSection, updateGeoSection, sectionId } = this.props
    sectionId ? updateGeoSection(sectionId, this.state) : createGeoSection(this.state)
  }

  handleDelete = () => this.props.deleteGeoSection(this.props.sectionId)

  render() {
    const { open, sectionId, closeModal } = this.props
    const { name, categories } = this.state
    const header = sectionId ? `Редактирование раздела ${sectionId}` : 'Создание раздела'
    return <Modal open={open}>
      <Modal.Header>{header}</Modal.Header>
      <Modal.Content>
        <Form>
          <Form.Field>
            <label>Название</label>
            <Input name='name' value={name} onChange={this.handleChange} />
          </Form.Field>
          <Form.Field>
            <label>Категории</label>
            <GeoCategoriesDropdown name='categories' value={categories} onChange={this.handleChange}/>
          </Form.Field>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button
          negative basic content='Удалить' icon='trash' floated='left'
          onClick={this.handleDelete}
          disabled={!sectionId}
        />
        <Button positive basic content='Сохранить' icon='check' onClick={this.handleSave} />
        <Button negative basic content='Отмена' icon='times' onClick={closeModal} />
      </Modal.Actions>
    </Modal>
  }
}

const mapStateToProps = state => ({
  open: state.dashboard.sectionModalOpen,
  sectionId: state.dashboard.selectedSectionId,
  geoSections: state.geoSections,
})

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    closeModal,
    createGeoSection,
    updateGeoSection,
    deleteGeoSection,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(SectionModal)
